/** Milliseconds per second */
export const MS_PER_SECOND = 1000;

/** Seconds in one hour */
export const SECONDS_PER_HOUR = 3600;

/** Seconds in one day */
export const SECONDS_PER_DAY = 86400;

/** Milliseconds in one day */
export const MS_PER_DAY = MS_PER_SECOND * SECONDS_PER_DAY;

/** Seconds per hour as bigint (for on-chain rate conversions) */
export const SECONDS_PER_HOUR_BI = 3600n;

/** Default debounce delay in milliseconds */
export const DEFAULT_DEBOUNCE_DELAY_MS = 500;

/** Query refetch intervals */
export const REFETCH_INTERVAL_FAST_MS = 5_000;
export const REFETCH_INTERVAL_MEDIUM_MS = 10_000;
export const REFETCH_INTERVAL_SLOW_MS = 15_000;
export const REFETCH_INTERVAL_LAZY_MS = 30_000;
export const REFETCH_INTERVAL_MINUTE_MS = 60_000;

/** Default stale time for React Query */
export const DEFAULT_STALE_TIME_MS = 10_000;

/** Countdown/timer update interval */
export const TIMER_TICK_INTERVAL_MS = 1_000;

/** Carousel transition speed */
export const CAROUSEL_SPEED_MS = 1_000;
